module.exports = __webpack_public_path__ + "cement/img/图像 290@2x.8cc18f69.png";